import FeedbackPage from '@/components/FeedbackPage'
import { MoonIcon } from '@heroicons/react/24/outline'

export default function SleepFactPage() {
  return (
    <FeedbackPage
      icon={<MoonIcon className="h-8 w-8 text-white" />}
      headingKey="pages.onboarding.sleepFact.heading"
      descriptionKey="pages.onboarding.sleepFact.description"
    />
  )
}
